import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { BackupType } from '@/types/backup'

type BackupsStoreState = {
  selectedBackupRunIds: string[]
  toggleBackupRunSelection: (id: string) => void
  selectAllBackupRuns: (runs: BackupType[]) => void
  deselectAllBackupRuns: () => void
  isBackupRunSelected: (id: string) => boolean
}

const useBackupsStore = create<BackupsStoreState>()(
  devtools((set, get) => ({
    selectedBackupRunIds: [],

    toggleBackupRunSelection: id =>
      set(state => ({
        selectedBackupRunIds: state.selectedBackupRunIds.includes(id)
          ? state.selectedBackupRunIds.filter(runId => runId !== id)
          : [...state.selectedBackupRunIds, id]
      })),

    selectAllBackupRuns: runs => set(() => ({ selectedBackupRunIds: runs.map(run => run.id) })),

    deselectAllBackupRuns: () => set(() => ({ selectedBackupRunIds: [] })),

    isBackupRunSelected: id => get().selectedBackupRunIds.includes(id)
  }))
)

export default useBackupsStore
